import React from 'react';

class DateSelector extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      MonthSelected: this.getDefaultMonth(props),
      YearSelected: this.getDefaultYear(props),
    };

    this.handleMonthChange = this.handleMonthChange.bind(this);
    this.handleYearChange = this.handleYearChange.bind(this);
    this.propogateOnChange = this.propogateOnChange.bind(this);
  }

  getDefaultYear (props) {
    if (Object.prototype.hasOwnProperty.call(props, 'defaultValue')) {
      const DefaultDate = new Date(props.defaultValue * 1000);
      return DefaultDate.getFullYear() + '';
    }
    return null;
  }

  getDefaultMonth (props) {
    if (Object.prototype.hasOwnProperty.call(props, 'defaultValue')) {
      const DefaultDate = new Date(this.props.defaultValue * 1000);
      return ('0' + (DefaultDate.getMonth() + 1)).slice(-2);
    }
    return null;
  }

  handleMonthChange (event) {
    const changeVal = {
      MonthSelected: event.target.value
    };
    this.setState(changeVal);
    this.propogateOnChange(Object.assign({}, this.state, changeVal));
  }

  handleYearChange (event) {
    const changeVal = {
      YearSelected: event.target.value
    };
    this.setState(changeVal);
    this.propogateOnChange(Object.assign({}, this.state, changeVal));
  }

  getDate (StateObject) {
    if (StateObject.MonthSelected !== null && StateObject.YearSelected !== null) {
      return new Date(parseInt(StateObject.YearSelected, 10), (parseInt(StateObject.MonthSelected, 10)) - 1);
    }
    return null;
  }

  propogateOnChange (state) {
    if (state.MonthSelected !== null && state.YearSelected !== null) {
      if (Object.prototype.hasOwnProperty.call(this.props, 'onChange')) {
        this.props.onChange({
          target: {
            value: (this.getDate(state).getTime()) / 1000,
          }
        });
      }
    }
  }

  getYears () {
    const currentDate = new Date();
    let returnArray = [];

    for (let x = 0; x < 5; x++) {
      returnArray.push(currentDate.getFullYear() + x);
    }

    return returnArray.map(Year => (
      <option key={'YearVal__' + Year} value={Year + ''}>{Year}</option>
    ));
  }

  render () {
    return (
      <div className='row'>
        <div className='col'>
          <select className='Form__Input Form__Input--white' defaultValue={this.state.YearSelected} onChange={this.handleYearChange} name='Year' required>
            <option>Year</option>
            {this.getYears()}
          </select>
        </div>
        <div className='col'>
          <select className='Form__Input Form__Input--white' defaultValue={this.state.MonthSelected} onChange={this.handleMonthChange} name='Month' required>
            <option>Month</option>
            <option value='01'>Jan</option>
            <option value='02'>Feb</option>
            <option value='03'>Mar</option>
            <option value='04'>Apr</option>
            <option value='05'>May</option>
            <option value='06'>Jun</option>
            <option value='07'>Jul</option>
            <option value='08'>Aug</option>
            <option value='09'>Sep</option>
            <option value='10'>Oct</option>
            <option value='11'>Nov</option>
            <option value='12'>Dec</option>
          </select>
        </div>
      </div>
    );
  }
}

export default DateSelector;



// WEBPACK FOOTER //
// ./src/routes/company/routes/Jobs/components/DateSelector/index.js